module.exports = __webpack_public_path__ + "static/media/010_Service Requestv2 @2x.9e0c651b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/farmers/010_Service Requestv2 @2x.png
// module id = 422
// module chunks = 0